<template>
  <action-type-template type="Origin" :action="action" :items="items" grid="origin" />
</template>

<script>
import ActionTypeTemplate from './ActionTypeTemplate'

export default {
  name: 'SportFootballMatchActionOrigin',
  components: { ActionTypeTemplate },
  props: {
    action: Object
  },
  computed: {
    items () {
      // Filter by type and remove particular case 'penalty' (id = 1)
      return this.$store.getters['Sport/Football/Action/Origin/list'].filter(
        (item) => { return item.typeId === this.action.typeId && item.id !== 1 }
      )
    }
  }
}
</script>
